import React from "react";

const Footer = ()=>{
    return (
        <div className="footer">
            <h3>Created by: Tumwesigye Ronnie</h3>
            <div className="menu">
                <a>Home</a>
                <a>About</a>
                <a>Contact</a>
                <a>Projects</a>
                <a>Qualifications</a>
            </div>
        </div>
    )
}

export default Footer;